import React, { Component } from 'react';
import format from 'string-format';

import Slider from '../../../../../../Shared/React/js/components/sliders/Slider';

export default class ModalDataSlider extends Component {
    constructor(props) {
        super(props);

        this.state = {
            rawValue: null
        };

        this.handleSliderValueChanged = this.handleSliderValueChanged.bind(this);
        this.handleSliderValueUpdating = this.handleSliderValueUpdating.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        return props.current === state.rawValue ? { rawValue: null } : null;
    }

    handleSliderValueChanged(value) {
        this.props.actions.changeData(value);
    }

    handleSliderValueUpdating(value) {
        this.setState({
            rawValue: value
        });
    }

    getLabel(value) {
        if (value === 0) {
            return <strong>{this.props.anyDataLabel}</strong>;
        } else if (value === -1) {
            return <strong>{this.props.values.find(v => v.key === value).value}</strong>;
        }

        return (
            <span
                dangerouslySetInnerHTML={{
                    __html: format(
                        this.props.atLeastLabel,
                        `<strong>${this.props.values.find(v => v.key === value).value}</strong>`
                    )
                }}
            />
        );
    }

    render() {
        const value = this.state.rawValue !== null ? this.state.rawValue : this.props.current;

        return (
            <React.Fragment>
                <div className="font-5">{this.getLabel(value)}</div>
                <div className="rc-slider-container pad-x-3 pad-x-5-xs mar-y-2">
                    <Slider
                        data={this.props.values.map(a => a.key)}
                        current={value}
                        onValueChanged={this.handleSliderValueChanged}
                        onValueUpdating={this.handleSliderValueUpdating}
                    />
                </div>
            </React.Fragment>
        );
    }
}
